/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {PacketVO} from '@/valueObjects/PacketVO'

const PACKET_CHUNK_SIZE = 5
const MAX_DISPLAYED_PACKETS = 100

export class PacketChunkVO {
    // Signature added to avoid implicit any (TS7017)
    [key: string]: any;

    /* fromServiceFormat takes a list of objects containing network packets
    and returns chunks of PacketVO.
    The size of the chunks is equal to PACKET_CHUNK_SIZE variable
     */
    public static fromServiceFormat(snakeCasedPacketInfoList: any): PacketChunkVO[] {
        const packetVOChunks: PacketChunkVO[] = []
        const nonEmptyPackets = snakeCasedPacketInfoList.filter(PacketChunkVO.filterEmptyPayload)

        const receivedPacketsNumber = nonEmptyPackets.length

        for (let i = 0; i < receivedPacketsNumber && i < MAX_DISPLAYED_PACKETS; i += PACKET_CHUNK_SIZE) {
            const receivedPacketChunk = nonEmptyPackets.slice(i, i + PACKET_CHUNK_SIZE)

            const packetVOList = []
            let chunkSize = 0
            for (const packet of receivedPacketChunk) {
                chunkSize += packet.size
                packetVOList.push(PacketVO.fromServiceFormat(packet))
            }

            packetVOChunks.push(new PacketChunkVO(chunkSize, packetVOList))
        }

        return packetVOChunks
    }

    private static filterEmptyPayload(snakeCasedPacket: object): boolean {
        return (snakeCasedPacket as PacketVO).payload !== ''

    }

    constructor(public size: number,
                public packets: PacketVO[],
    ) {
    }
}
